export default __webpack_public_path__ + "static/24-30352ee263c335988f9fa791f289dca9.jpg";